import { Shinsei } from "@/types/Shinsei";
import { ref } from "vue";
import { useRoute } from 'vue-router';
import OptionConst from "@/const/Option";

/*
 * 初期処理
 */
export function useInit() {
  const route = useRoute()
  const name = route.name
  const type = route.params.type as string
  const id = parseInt(route.params.id as string, 10)

  const setShinseiType = (shinseiType: string): number => {
    return Number(OptionConst.SHINSEI_CODE_TYPE.find(v => v.type == shinseiType)?.code)
  }

  // 申請form情報
  const form = ref<Shinsei>({
    shinsei_date: null,
    shinsei_type: setShinseiType(route.params.type as string) ?? null,
    shinsei_type_str: route.params.type as string,
    is_torikeshi: null,
    keitai_type: null,
    koyou_keiyaku_id: null,
    mst_syuugyou_basyo_id: null,
    notes: null,
    shinsei_id: null,
    shinsei_jiyuu: null,
    staff_code: null,
    staff_name: null,
    syounin_status_type: null,
    syuugyou_basyo_name: null,
    user_id: null,
    idou: null,
    yuukyuu: null,
    chikoku: null,
    dakoku_syuusei: null,
    furikyuu: null,
    jikangai: null,
    kekkin: null,
    kibiki: null,
    kiken: null,
    kosyoku: null,
    nittyoku: null,
    sonota: null,
    soutai: null,
    moto_shinsei_id: null,
    kyuukei_jikangai: null,
    shinsei_koyou_keiyaku_time: [],
    is_soumu_changed: false,
    hayaban_osoban: null,
    koukyuu: null,
    approval_data: null
  });

  return {
    form,
    type,
    id,
    name,
    setShinseiType,
  }
}
